import React, { Component } from 'react';
import ResultBookList from './ResultBookList';
import '../styles/ResultPage.css';
import { Link } from 'react-router-dom';
// import background from '../images/fantasy-2750995_1920.jpg';


class ResultPage extends Component {

  renderError = () => {
    if (this.props.recommendations.errors) return (
    <div className='ResultPageError'>
      <p>Sorry... We're not able to create any recommendations to you based on your selected books. :(</p>
      <p>Are you sure that you only included the first book of a series, if one of your picks we're part of a series?</p>
    </div>
    )
  }

  render() {
    return (
      <div className='ResultPage'>
        <div className='ResultPageHeader'>
          <Link
            to={'/'}>
            <input type='button' className='ResultPageHeaderButton' onClick={this.props.backToFirstPage} value='Start again?'/>
          </Link>
        </div>
        <ResultBookList recommendations={this.props.recommendations}/>
        {this.renderError()}
      </div>
    )
  }
}

export default ResultPage;


// WEBPACK FOOTER //
// ./src/components/ResultPage.js